/* eslint-disable no-unused-vars */
import { useState } from 'react'
import { TabBarProvider, usePage, useTabBarContext, useGame } from '../../contexts'

import HomeMobile from '../home-mobile'
import Feed from '../feed'
import More from './more'
import ChangePassword from '../../../main/factories/pages/change-password'
import { WrapperMobile, ChatSpace } from './styles'
import TabItem from '../../components/tab-item'
import { t } from '../../adapters/translate/translate'
import { getLocalStorage } from '../../utils/storage_helpers'
import TawkMessengerReact from '@tawk.to/tawk-messenger-react'
import { isMobile } from '../../utils/general'
import { getAssetUrl } from '../../utils/assets_helpers'
import HelpModal from '../../components/modais/help_modal'
import MoreDesktop from './more-desktop'
import { AlertBox } from '../../components/ui/layout'
import { getUser } from '../../utils/storage/user'

const Tab = () => {
  const [showMoreComponent, setShowMoreComponent] = useState<boolean>(false)
  const support = getLocalStorage('support') ? JSON.parse(getLocalStorage('support') || '') : null
  const { toggleInstructions } = usePage()
  const { game, handleToggleChangeGameModal } = useGame()
  const { handleChangeTab } = useTabBarContext()
  const [openHelpModal, setOpenHelpModal] = useState<any>(false)
  const user = getUser()

  const openDocument = () => {
    window.open(getAssetUrl('documentAttachment', game?.documentAttachment))
  }
  const openSupport = () => {
    support && (
      support.type === 'WhatsApp' && (
        window.open(support.link, '_blank')
      ))
  }

  const tabs = [
    {
      content: HomeMobile,
      name: 'initial',
      title: t('Home'),
      activeIcon: 'RiHome3Fill',
      icon: 'RiHome2Line'
    },
    {
      content: Feed,
      name: 'feed',
      title: 'Feed',
      activeIcon: 'RiDashboardFill',
      icon: 'RiDashboardLine'
    },
    {
      content: null,
      name: 'more',
      title: t('More'),
      activeIcon: 'RiMenuLine',
      icon: 'RiMenuLine',
      action: () => setShowMoreComponent(true)
    },
    {
      content: ChangePassword,
      name: 'changePassword',
      title: '',
      activeIcon: '',
      icon: ''
    }
  ]

  const LIST_ITEMS = [
    {
      content: HomeMobile,
      name: 'initial',
      title: t('Home'),
      activeIcon: 'RiHome3Fill',
      icon: 'RiHome2Line'
    },
    {
      content: Feed,
      name: 'feed',
      title: 'Feed',
      activeIcon: 'RiDashboardFill',
      icon: 'RiDashboardLine'
    },
    {
      content: null,
      name: 'Instructions',
      title: t('Instructions'),
      activeIcon: 'RiTodoLine',
      icon: 'RiTodoLine',
      action: toggleInstructions
    },
    {
      content: null,
      name: 'more',
      title: t('More'),
      activeIcon: 'RiMenuLine',
      icon: 'RiMenuLine',
      action: () => setShowMoreComponent(true)
    }
  ]

  user && (
    LIST_ITEMS.splice(2, 0, {
      content: null,
      name: 'ChangeGame',
      title: t('Change Game'),
      icon: 'RiEditFill',
      activeIcon: 'RiEditFill',
      action: handleToggleChangeGameModal
    })
  )

  support && (
    support.type === 'WhatsApp' && (
      LIST_ITEMS.splice(4, 0, {
        content: null,
        name: 'Support',
        title: t('Support'),
        activeIcon: 'WhatsApp',
        icon: 'WhatsApp',
        action: () => openSupport()
      })
    ))

  !support && (
    LIST_ITEMS.splice(4, 0, {
      content: null,
      name: 'Support',
      title: t('Support'),
      activeIcon: 'RiMessageFill',
      icon: 'RiMessageFill',
      action: () => setOpenHelpModal(true)
    })
  )

  if (game?.documentAttachment) {
    LIST_ITEMS.splice(1, 0,
      {
        content: null,
        name: 'Document',
        title: t('Document'),
        icon: 'RiFile2Fill',
        activeIcon: 'RiFile2Fill',
        action: () => openDocument()
      })
  }

  return (
    <>
      <TabBarProvider tabs={tabs}>
        {
          support && (
            support.type === 'TawkTo' && (
              <>
                <TawkMessengerReact
                  propertyId={support.settings.propertyId}
                  widgetId={support.settings.widgetId}/>
                <ChatSpace></ChatSpace>
              </>
            )
          )
        }

        <WrapperMobile $isMobile={isMobile()}>
          { isMobile() && support && support.type === 'TawkTo' && (
            <ChatSpace></ChatSpace>
          )}

          {
            isMobile()
              ? tabs.map((item, index) => (
                <TabItem content={item} key={index} $isMobile={isMobile()}/>
              ))

              : LIST_ITEMS.map((item, index) => (
               <TabItem content={item} key={index} $isMobile={isMobile()}/>
              ))
          }
        </WrapperMobile>
        {isMobile()
          ? <More
            isVisible={showMoreComponent}
            close={() => setShowMoreComponent(false)}
          />
          : <MoreDesktop
          isVisible={showMoreComponent}
          close={() => setShowMoreComponent(false)}
        />
      }

      </TabBarProvider>
      <AlertBox />
      {openHelpModal && <HelpModal isAnonymous={false} handleClose={() => setOpenHelpModal(false)} />}
    </>
  )
}

export default Tab
